import {
  reportNumberFormat,
  formatIndianNumber,
  REPORT_AMOUNT_CLASS,
  REPORT_AMOUNT_HEADER_CLASS,
} from '../../../utils/reportFormat';

/** Indian-formatted currency / amount (2 decimals, right-aligned in tables). */
export const wsAmount = (value) => reportNumberFormat(value);

/** Indian-formatted quantity / reading (2 decimals, right-aligned in tables). */
export const wsQty = (value) => formatIndianNumber(value, 2);

export { REPORT_AMOUNT_CLASS, REPORT_AMOUNT_HEADER_CLASS };

export function wsSignedAmount(value) {
  return reportNumberFormat(value);
}
